import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";
import PrivateRoute from "./routes/PrivateRoute";
import "./global.css"
import Skeleton from "./components/skeleton/Skeleton";


// Lazy imports
const Login = lazy(() => import("./pages/login/Login"));
const Signup = lazy(() => import("./pages/signup/Signup"));
const VerifyOTP = lazy(() => import("./pages/verifyotp/VerifyOTP"));
const Booking = lazy(() => import("./pages/booking/Booking"));
const MyBooking = lazy(() => import("./pages/mybooking/MyBooking"));
const Home = lazy(() => import("./pages/home/Home"));
const UpdateUser = lazy(() => import("./pages/updateuser/UpdateUser"));
const ReviewBooking = lazy(() => import("./pages/reviewbooking/ReviewBooking"));
const Response = lazy(() => import("./pages/response/Response"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Skeleton />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify" element={<VerifyOTP />} />
          <Route path="/booking" element={<Booking />} />

          <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/updateuser" element={<PrivateRoute><UpdateUser /></PrivateRoute>} />
          <Route path="/review" element={<PrivateRoute><ReviewBooking /></PrivateRoute>} />
          <Route path="/mybooking" element={<PrivateRoute><MyBooking /></PrivateRoute>} />
          <Route path="/booking-status" element={<PrivateRoute><Response /></PrivateRoute>} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;